import styled from 'styled-components';
export const StyledStepProgressIndicator = styled.div.withConfig({
  displayName: "StepProgressIndicatorstyle__StyledStepProgressIndicator",
  componentId: "fzb2mt-0"
})(["position:absolute;top:60px;left:0;display:flex;grid-area:subheader;z-index:1;width:100%;justify-content:center;"]);
export const StepProgressIndicatorWrapper = styled.div.withConfig({
  displayName: "StepProgressIndicatorstyle__StepProgressIndicatorWrapper",
  componentId: "fzb2mt-1"
})(["width:60%;display:flex;"]);